import { render } from "./FuzokuMeisaiJunsokuMenu.vue?vue&type=template&id=70657c1a&scoped=true&ts=true"
import script from "./FuzokuMeisaiJunsokuMenu.vue?vue&type=script&lang=ts"
export * from "./FuzokuMeisaiJunsokuMenu.vue?vue&type=script&lang=ts"

import "./FuzokuMeisaiJunsokuMenu.vue?vue&type=style&index=0&id=70657c1a&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70657c1a"]])

export default __exports__